export const formatter = new Intl.NumberFormat("de-CH", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
export const procformatter = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: "2",
});
